import styled from "styled-components";
import dotSVG from './assets/dot.svg'
import papertape1 from './assets/papertape1.png'
import papertape2 from './assets/papertape2.png'
import papertape3 from './assets/papertape3.png'
import papertape4 from './assets/papertape4.png'
import papertape5 from './assets/papertape5.png'


type Props = {
    $rotate?: number
}

export default styled.div<Props>`
    display: inline-block;
    position: relative;
    flex-direction: column;
    box-shadow: -0.4em 0.4em 0.8em 0.1em rgba(76, 53, 73, 0.2);
    font-family: "Reenie Beanie", cursive;
    font-weight: 400;
    font-style: normal;
    font-size: 28px;
    letter-spacing: -1px;
    line-height: 0.9em;
    color: #333333;
    filter: contrast(115%) brightness(90%) blur(0.01em);
    margin-left: 5rem;
    margin-top: 2rem;
    transition: filter .2s ease-in-out;
    z-index: 9;


    ${({ $rotate }) => $rotate && `
        transform: rotate(${$rotate}deg);
    `}

    & ::selection {
        color: #333333;
        background: #fff5009c;
    }

    &::after {
        content: ' ';
        display: block;
        position: absolute;
        width: 160px;
        height: 86px;
        left: 50%;
        margin-left: -5rem;
        transform: rotate(5deg);
        background-size: 100% auto;
        background-position: 2px 12px;
        background-repeat: no-repeat;
        z-index: 10;
        opacity: 0.85;
    }

    &:nth-child(1)::after {
        background-image: url(${papertape2});
        transform: rotate(-5deg);
        top: -40px;
    }
    &:nth-child(2)::after {
        background-image: url(${papertape1});
        top: -35px;
    }
    &:nth-child(3)::after {
        background-image: url(${papertape3});
        top: -30px;
    }
    &:nth-child(4)::after {
        background-image: url(${papertape4});
        transform: rotate(-5deg);
        top: -55px;
    }
    &:nth-child(5)::after {
        background-image: url(${papertape5});
        top: -30px;
    }

    &:before {
        content: ' ';
        position: absolute;
        left: 0;
        right: 0;
        bottom: 0;
        top: 0;
        background: rgba(0,0,0,0.4);
        z-index: 4;
        filter: blur(1px);
        transform: 
            translate(-1.5%, 2px)
            translateZ(-100px)
            rotateX(5deg)
            rotateY(-5deg)
            rotateZ(2deg)
            skewX(1deg)
            skewy(-2deg)
            scale(1, 1);
    }

    & h1, & h2, & h3, & h4, & h5 {
        font-weight: 800;
        padding: 0;
        margin: 0 0 0.25em 0;
    }

    & h1 {
        margin: 0 0 0.45em 0;
    }

    & ul {
        margin: 0;
        padding: 0;
    }

    & li {
        list-style: none;
        background-image: url(${dotSVG});
        background-repeat: no-repeat;
        background-position: left center;
        background-size: 8px;
        padding-left: 20px;
        line-height: 1em;
        font-family: "Grape Nuts", cursive;
        font-weight: 400;
        font-style: normal;
    }

    & p {
        padding: 0;
        margin: 0.5em 0 0.5em 0;
    }

    & a {
        color: #0d0d0d;
        font-weight: 400;
        font-style: normal;
        display: inline-block;
        cursor: pointer;
        text-decoration: none;
        text-underline-offset: 5px;
    }

    & a:hover {
        text-decoration: underline;
    }

    & img {
        pointer-events: none;
    }

    @media screen and (max-width: 1600px) {
        margin-left: 0;
        margin-right: 3rem;
        margin-top: 2rem;
    }

    @media screen and (max-width: 1260px) {
        margin-left: 0;
        margin-right: 3rem;
        margin-top: 1rem;
    }

    

    @media screen and (max-width: 920px) {
        margin-right: 4rem;
        margin-top: 1rem;
    }


    @media screen and (max-width: 600px) {
        margin-right: 0;
        margin-top: 5rem;

        &:first-child {
            margin-top: 1rem;
        }
    }

`
